// Test IDs for the tour search landing page
export const TOUR = {
  // Header
  logo: 'header-logo',
  navPhones: 'header-nav-phones',

  // Hero
  heroTitle: 'hero-title',
  heroSubtitle: 'hero-subtitle',
  heroCtaScroll: 'hero-cta-scroll',
  heroPreviewCard: 'hero-preview-card',

  // Search widget
  searchWidget: 'search-widget',
  searchSection: 'tour-search-section',
  searchTitle: 'tour-search-title',
  searchSubtitle: 'tour-search-subtitle',
  tabTours: 'search-tab-tours',
  tabHotels: 'search-tab-hotels',
  tabHot: 'search-tab-hot',
  fieldFrom: 'field-from',
  fieldDestination: 'field-destination',
  fieldDate: 'field-date',
  fieldNights: 'field-nights',
  fieldAdults: 'field-adults',
  fieldChildren: 'field-children',
  fieldCategory: 'field-category',
  fieldBudget: 'field-budget',
  fieldFood: 'field-food',
  fieldHotelName: 'field-hotel-name',
  btnSearch: 'btn-search-tours',
  btnPickForMe: 'btn-pick-for-me',
  loadingState: 'search-loading',

  // Results
  resultsSection: 'search-results',
  resultsCount: 'results-count',
  tourCard: 'tour-card',
  tourCardCta: 'tour-card-cta',
  disclaimer: 'preliminary-disclaimer',

  // Lead modal
  leadDialog: 'lead-dialog',
  leadName: 'lead-name-input',
  leadPhone: 'lead-phone-input',
  leadTelegram: 'lead-telegram-input',
  leadDestination: 'lead-destination-input',
  leadBudget: 'lead-budget-input',
  leadNotes: 'lead-notes-input',
  leadTourInfo: 'lead-tour-info',
  leadSubmit: 'lead-submit-btn',
  leadCancel: 'lead-cancel-btn',
  leadSuccess: 'lead-success-message',

  // Owner
  ownerSection: 'owner-section',
  ownerTelegramBtn: 'owner-telegram-btn',

  // Contacts
  contactsSection: 'contacts-section',
  contactNatalya: 'contact-natalya',
  contactInna: 'contact-inna',
  contactYuliya: 'contact-yuliya',
  contactEmail: 'contact-email',
  fallbackCtaBtn: 'fallback-cta-btn',
  widgetPlaceholder: 'tourvisor-widget-placeholder',

  // Admin
  adminSection: 'admin-section',
  adminPasswordInput: 'admin-password-input',
  adminLoginBtn: 'admin-login-btn',
  adminTable: 'admin-requests-table',
  adminMarkProcessed: 'admin-mark-processed',
  adminDelete: 'admin-delete',
  adminView: 'admin-view',
  adminLogout: 'admin-logout',
};
